/**
 * @desc 获取年度销售计划详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 年度销售计划ID */
  salePlanId: string;
  /** 计划类型包括发运计划1地销计划2统销计划3粉磨站计划4 */
  salePlanType: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPlanSaleYearDetailResponse>>> {
  return defHttp.get({
    url: '/web/sale/year/searchDetail',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPlanSaleYearDetailResponse>>> {
  return defHttp.get({
    url: '/mock/web/sale/year/searchDetail',

    params,
  });
}
